/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ImportantMessageDto } from './importantMessageDto.model';
import { BlockRequestsType } from './blockRequestsType.model';


export interface StateUpdateDto { 
    applicationVersion?: string;
    asyncOperationsCount?: number;
    blockRequests?: BlockRequestsType;
    cuzkPasswordValidityState?: number;
    existContractBulkOperation?: boolean;
    messages?: Array<ImportantMessageDto>;
    readNotificationsCount?: number;
    skippedDateDueCuzkPasswordValidity?: string;
    unreadNotificationsCount?: number;
}
export namespace StateUpdateDto {
}


